import React, { useState } from "react";
import { useMutation } from "@apollo/react-hooks";
import TextField from '@mui/material/TextField';

import './desktop-password-reset-style.scss';

import Button from "@src/componentsNew/Buttons/Button";
import Typography from "@src/componentsNew/Typography/Typography";

import { CUSTOMER_PASSWORD_RESET } from "./queries";
import { customerPasswordReset } from "./__generated__/customerPasswordReset";

import { EMAIL_REGEX } from "@src/utils/constants";

const DesktopPasswordResetPage = () => {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');

  const [resetPassword, { loading }] = useMutation<customerPasswordReset>(CUSTOMER_PASSWORD_RESET, {
    onCompleted: () => {
      setStep(2);
    }
  });

  const validateEmail = (email: string) => {
    return EMAIL_REGEX.test(email);
  };

  const handleClick = (e: any) => {
    if (!validateEmail(email)) {
      setEmailError('Please enter a valid email address');
      return;
    }

    setEmailError('');
    resetPassword({
      variables: {
        input: {
          email
        }
      }
    });
  };

  return (
    <div id="desktop-password-reset-wrapper">
      <div className="password-reset-content-wrapper">
        <Typography variant="h6" component="h4">
          {step === 1 ? "Enter Email" : "Check Your Email"}
        </Typography>

        {
          step === 1 ? (
            <Typography cName="info-text" variant="body1" component="p">
              {"Enter the email with your account\nand we’ll send an email with instructions."}
            </Typography>
          ) : (
            <div className="check-info-text-wrapper">
              <Typography cName="info-text" variant="body1" component="p">
                {`We sent an email to ${email}`}
              </Typography>
              <Typography cName="info-text" variant="body1" component="p">
                {"Click on the link in that email to reset\npassword. Please check your spam folder if\nnot received."}
              </Typography>
            </div>
          )
        }

        {
          step === 1 ?
            <TextField
              type="email"
              size="medium"
              className="email-input"
              label="Email Address"
              placeholder="Email Address"
              onChange={(e) => setEmail(e.target.value)}
              value={email}
              error={!!emailError}
              helperText={emailError}
              fullWidth
            /> : null
        }

        <Button
          size="large"
          cName={`submit-btn step${step}`}
          variant={step === 1 ? "contained" : "outlined"}
          disabled={loading}
          onClick={handleClick}>
          {step === 1 ? "Continue" : "Resend Email"}
        </Button>
      </div>
    </div>
  )
};

export default DesktopPasswordResetPage;
